import http from 'helpers/requests';

// verifier-firm-foundation phase 4 — the verifier's engagements.
const unwrap = (promise) => promise.then((response) => response.data);
const base = '/verifier/engagements';

export const fetchMyEngagements = () => unwrap(http.get(base));
export const fetchEngagement = (id) => unwrap(http.get(`${base}/${encodeURIComponent(id)}`));
export const saveStaffing = (id, staffing) =>
  unwrap(http.put(`${base}/${encodeURIComponent(id)}/staffing`, { staffing }));
export const saveOutsourcing = (id, body) =>
  unwrap(http.put(`${base}/${encodeURIComponent(id)}/outsourcing`, body));
export const fetchLegacyGrant = (grantId) =>
  unwrap(http.get(`/verifier/legacy-grants/${encodeURIComponent(grantId)}`));
